
import { Dealer } from "@/types/dealer";
import { safeLocalStorage } from "@/utils/safeStorage";
/**
 * Retrieve fallback dealer data from localStorage
 * This is used when API requests fail to ensure we always have data to display
 */
export const getFallbackDealersData = (metalType?: string): Dealer[] => {
  // SSR check - return empty array on server
  if (typeof window === 'undefined') return [];
  
  try {
    // If a specific metal type is requested, try that first
    if (metalType) {
      const fallbackData = safeLocalStorage.getItem(`fallback-dealers-${metalType}`);
      if (fallbackData) {
        const parsedData = JSON.parse(fallbackData);
        if (Array.isArray(parsedData) && parsedData.length > 0) {
          return ensureDealerCompatibility(parsedData);
        }
      }
    }
    
    // Try general fallback data
    const fallbackData = safeLocalStorage.getItem('fallback-dealers');
    if (fallbackData) {
      const parsedData = JSON.parse(fallbackData);
      if (Array.isArray(parsedData) && parsedData.length > 0) {
        return ensureDealerCompatibility(parsedData);
      }
    }
    
    // If no localStorage data, return empty array - no mock data
    return [];
  } catch (e) {
    console.error('Error retrieving fallback data:', e);
    return [];
  }
};

/**
 * Ensure dealer data conforms to the Dealer interface
 */
function ensureDealerCompatibility(dealers: any[]): Dealer[] {
  return dealers.map(dealer => {
    // Ensure required fields are present
    return {
      id: dealer.id || '',
      name: dealer.name || '',
      address: dealer.address || '',
      city: dealer.city || '',
      is_verified: dealer.is_verified ?? dealer.activated ?? false,
      activated: dealer.activated ?? false,
      isFavorite: dealer.isFavorite ?? false,
      latitude: dealer.latitude || 0,
      longitude: dealer.longitude || 0,
      rating: typeof dealer.rating === 'number' ? dealer.rating : 0,
      buySpread: typeof dealer.buySpread === 'number' ? dealer.buySpread : undefined,
      phone: dealer.phone || '',
      email: dealer.email || '',
      postal_code: dealer.postal_code || '',
      image_url: dealer.image_url || '',
      opening_hours: dealer.opening_hours || ''
    };
  });
}
